import React, { useState, useEffect } from 'react';
import { t } from 'i18next';
import ErrorPageNoBack from '../Simple/ErrorPageNoBack';

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (error, errorInfo) => {
      setHasError(true);

      if (window.newrelic) {
        window.newrelic.noticeError(error, {
          componentStack: errorInfo ? errorInfo.componentStack : null,
          message: error.message,
          name: error.name,
        });
      }
    };

    const handleWindowError = (event) => {
      handleError(event.error || new Error(event.message));
    };

    window.addEventListener('error', handleWindowError);

    return () => {
      window.removeEventListener('error', handleWindowError);
    };
  }, []);

  const errorPageComponent = () => (
    <ErrorPageNoBack
      title={t('titleErrorPage')}
      text={t('subtitleErrorPage')}
      subtext={t('msgErrorPage')}
    />
  );

  return hasError ? errorPageComponent() : children;
};

export default ErrorBoundary;
